<template>
    <div>
      <group-name-search class="mr-5"  :event-token="eventToken" @search="handleSearch" />
      <moderator-search class="mr-5"  :event-token="eventToken" @search="handleSearch" />
      <staff-search  class="mr-5" :event-token="eventToken" @search="handleSearch" />
    </div>
  </template>
  
  <script>
  import GroupNameSearch from '@/components/buscadores/GroupNameSearch.vue';
  import ModeratorSearch from '@/components/buscadores/ModeratorSearch.vue';
  import StaffSearch from '@/components/buscadores/StaffSearch.vue';
  
  export default {
    components: {
      GroupNameSearch,
      ModeratorSearch,
      StaffSearch
    },
    props: {
      eventToken: {
        type: String,
        required: true
      }
    },
    methods: {
      handleSearch(result) {
        // Manejar la lógica de búsqueda aquí o emitir evento al nivel superior si es necesario
        console.log('Search results:', result);
      }
    }
  }
  </script>
  